import { needsReview, type DsdReviewMatchItem } from "./selected-cell-view";

/** 후보 카드의 톤 표현 — 패널 카드와 검토 모달의 카드 요약이 같은 것을 쓴다 (수정 지점 하나) */
export const TONE_RING: Record<DsdReviewMatchItem["tone"], string> = {
  positive: "ring-green-500",
  caution: "ring-amber-500",
  negative: "ring-rose-500",
};
/** 근거 창이 이 카드의 후보를 띄우고 있을 때의 중립 선택 색 — 본문·주석, 주석·주석 패널 카드가 같이 쓴다 */
export const SELECTED_EVIDENCE_CLASS = "bg-slate-50 ring-slate-500";
/**
 * 주석 관계 칩의 톤 — 검토 쌍이 있는 후보는 검토 전·후 모두 자기 톤(패널의 검토 완료 카드는 흐림만), 그 외는 "positive" = 회색 칩.
 * 패널 카드와 근거 창 머리글이 같은 규칙을 쓴다
 */
export const tagToneOf = (item: DsdReviewMatchItem) =>
  needsReview(item) ? item.tone : "positive";
